<template>
  <v-card v-if="!isAdmin" flat color="#e9e8ed" height="100%">
    <v-card
      class="dash-card rounded-lg"
      flat
      style="min-height: 80; height: 78%; width: 100%"
      :class="{ 'mb-n5': !mdAndUp }"
    >
      <v-btn
        icon
        x-small
        class="refresh-button"
        @click="refreshDashCard"
        v-if="mdAndUp && refreshInfo !== ''"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-card-title
        class="d-flex justify-center pt-2 pb-3 fontDash-title mb-n2"
        :class="{ 'text-subtitle-2 mb-n10': !mdAndUp }"
      >
        {{ title }}
      </v-card-title>
      <v-card-text class="d-flex justify-center align-center mb-1">
        <v-progress-circular
          :size="60"
          :color="$config.dados.corinputs"
          v-if="loading"
          indeterminate
          class="mt-n2"
        ></v-progress-circular>
        <v-row justify="start" v-else>
          <template v-if="mdAndUp">
            <template v-if="information">
              <v-col cols="12" sm="8" class="d-flex flex-column align-center">
                <span
                  v-for="(infoTitle, index) in information.titles"
                  :key="index"
                  class="text-body-2"
                >
                  {{ infoTitle }}
                </span>
              </v-col>
              <v-col cols="12" sm="1" class="d-flex flex-column align-start">
                <span
                  v-for="(infoValues, index) in information.values"
                  :key="index"
                  class="text-body-2"
                >
                  {{ infoValues }}
                </span>
              </v-col>
            </template>
            <v-row justify="center">
              <template v-if="percent && mdAndUp">
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  class="d-flex flex-column align-center"
                >
                  <h1
                    v-if="percent.value"
                    :class="percent.class"
                    class="mb-6 text-h4"
                  >
                    {{ percent.value }}
                  </h1>
                </v-col>
              </template>
              <template v-if="percent && !mdAndUp">
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  class="d-flex flex-column align-center"
                >
                  <h1
                    v-if="percent.value"
                    :class="percent.class"
                    class="mb-6 text-h2"
                  >
                    {{ percent.value }}
                  </h1>
                </v-col>
              </template>
              <template v-if="info">
                <h1 :class="percent.class" class="mb-6 text-h2">
                  {{ info }}
                </h1>
              </template>
            </v-row>
          </template>
          <template v-else>
            <template v-if="information">
              <v-col cols="6" class="d-flex flex-column align-center">
                <span
                  v-for="(infoTitle, index) in information.titles"
                  :key="index"
                  class="text-body-2"
                >
                  {{ infoTitle }}
                </span>
              </v-col>
              <v-col cols="6" class="d-flex flex-column align-center">
                <span
                  v-for="(infoValues, index) in information.values"
                  :key="index"
                  class="text-body-2"
                >
                  {{ infoValues }}
                </span>
              </v-col>
            </template>
            <v-divider v-if="information"></v-divider>
            <template v-if="percent">
              <v-col
                cols="12"
                class="d-flex flex-column align-center justify-space-between mt-8"
              >
                <h1 :class="percent.class" class="mb-6 text-h5">
                  {{ percent.value }}
                </h1>
                <span>{{ percent.text }}</span>
              </v-col>
            </template>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </v-card>
  <v-card
    v-else
    elevation="0"
    class="card-dashboard rounded-lg"
    :class="isValueBRL ? 'tertiary' : 'white'"
  >
    <v-btn
      icon
      small
      class="refresh-button"
      :class="isValueBRL ? 'white--text' : 'black--text'"
      @click="refreshDashCard"
      v-if="mdAndUp"
    >
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
    <v-card-title
      class="d-flex justify-start pt-2 pb-6 text-subtitle-1"
      :class="{ 'text-subtitle-1': !mdAndUp }"
      style="font-family: 'Archivo', sans-serif !important"
      v-if="shouldShowCards"
    >
      {{ title }}
      <v-tooltip right v-if="infoCard">
        <template v-slot:activator="{ on }">
          <v-btn icon small v-on="on" color="tertiary">
            <v-icon>mdi-information</v-icon>
          </v-btn>
        </template>
        <span>
          {{ infoCard }}
        </span>
      </v-tooltip>
    </v-card-title>
    <v-card-text
      class="d-flex flex-row justify-center align-center"
      style="min-height: 150px"
    >
      <v-progress-circular
        :size="70"
        :color="isValueBRL ? 'white' : 'tertiary'"
        v-if="loading"
        indeterminate
      ></v-progress-circular>
      <v-row justify="start" v-else>
        <template>
          <template v-if="information">
            <v-col
              md="7"
              cols="12"
              class="pa-2"
              v-if="information.values.length > 1"
            >
              <div v-if="mdAndUp">
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" color="tertiary">
                      <v-icon>mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <span v-html="infoSpark"></span>
                </v-tooltip>
                <v-sparkline
                  :value="valuesInfo"
                  height="50"
                  width="100"
                  padding="14"
                  stroke-linecap="round"
                  smooth
                  color="tertiary"
                  auto-draw-easing
                  auto-draw
                  :auto-draw-duration="3000"
                  label-size="6"
                  :labels="information.values"
                >
                </v-sparkline>
              </div>
              <div v-else>
                <v-list
                  v-for="(infoTitle, index) in information.titles"
                  :key="index"
                  class="d-flex flex-row justify-space-between px-2"
                  style="width: 100%"
                >
                  <span class="text-subtitle-1 font-weight-bold">{{
                    infoTitle
                  }}</span>
                  <span class="text-subtitle-1">{{
                    information.values[index]
                  }}</span>
                </v-list>
              </div>
            </v-col>
            <v-col cols="12" class="pa-2" v-else>
              <v-icon
                style="border: 2px solid var(--v-base-base)"
                class="pa-2 rounded-lg deep-purple lighten-5"
                color="#572c88"
                size="30"
              >
                mdi-account-group
              </v-icon>
              <p
                class="d-flex justify-start pt-2 pb-2 text-subtitle-1"
                style="color: #000000de"
              >
                {{ title }}
              </p>
              <div
                class="d-flex align-end"
                :class="{ 'justify-space-between': !mdAndUp }"
              >
                <h1
                  class="text-h3"
                  :class="{ 'text-h4': !mdAndUp }"
                  style="
                    font-family: 'Archivo', sans-serif !important;
                    color: #572c88;
                  "
                >
                  {{ information.values[0] }}
                </h1>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-chip
                      v-on="on"
                      class="mb-2 d-flex align-center justify-center ml-3"
                      :class="
                        isNegative ? 'negative-percent' : 'positive-color'
                      "
                      :color="isNegative ? 'red lighten-4' : 'green lighten-4'"
                      style="cursor: pointer"
                    >
                      {{ percent.value }}
                      <v-icon
                        small
                        class="ml-2"
                        :class="
                          isNegative ? 'negative-percent' : 'positive-color'
                        "
                      >
                        {{ isNegative ? "mdi-arrow-down" : "mdi-arrow-up" }}
                      </v-icon>
                    </v-chip>
                  </template>
                  <span>{{ percent.text }}</span>
                </v-tooltip>
              </div>
            </v-col>
          </template>
          <template v-if="percent">
            <v-col cols="12" sm="6" md="12" v-if="isValueBRL" class="pt-2">
              <v-icon
                style="border: 2px solid var(--v-base-base)"
                class="pa-2 rounded-lg deep-purple lighten-5"
                color="#572c88"
                size="30"
              >
                mdi-currency-usd
              </v-icon>
              <p
                class="d-flex justify-start pt-2 pb-2 text-subtitle-1 white--text"
              >
                {{ title }}
              </p>
              <h1
                :class="{ 'text-h4': !mdAndUp }"
                class="text-h3 white--text"
                style="font-family: 'Archivo', sans-serif !important"
              >
                {{ percent.value }}
              </h1>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="5"
              :class="
                mdAndUp
                  ? 'd-flex flex-column align-center justify-space-between'
                  : ''
              "
              v-else
            >
              <v-tooltip bottom v-if="isProducers">
                <template v-slot:activator="{ on }">
                  <v-chip
                    v-on="on"
                    class="mb-2 d-flex align-center justify-center"
                    :class="isNegative ? 'negative-percent' : 'positive-color'"
                    :color="isNegative ? 'red lighten-4' : 'green lighten-4'"
                    style="cursor: pointer"
                  >
                    {{ percent.value }}
                    <v-icon
                      small
                      class="ml-2"
                      :class="
                        isNegative ? 'negative-percent' : 'positive-color'
                      "
                    >
                      {{ isNegative ? "mdi-arrow-down" : "mdi-arrow-up" }}
                    </v-icon>
                  </v-chip>
                </template>
                <span>{{ percent.text }}</span>
              </v-tooltip>
            </v-col>
          </template>
        </template>
        <template v-if="list">
          <v-col cols="12">
            <v-list
              color="rounded-lg d-flex flex-column justify-center align-center"
            >
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                class="d-flex flex-row justify-space-between mb-2"
                style="
                  width: 100%;
                  border-bottom: thin solid rgba(0, 0, 0, 0.12);
                "
              >
                <v-container v-if="item.descricao">
                  <span
                    class="text-subtitle-1 font-weight-bold"
                    style="font-family: 'Archivo', sans-serif !important"
                    >{{ index + 1 }}. {{ item.descricao | cutText(20) }}</span
                  >
                </v-container>
                <v-container v-if="item.loja && !item.nome && !item.descricao">
                  <span
                    class="text-subtitle-1 font-weight-bold"
                    style="font-family: 'Archivo', sans-serif !important"
                    >{{ index + 1 }}. {{ item.loja }}</span
                  >
                </v-container>
                <v-container v-if="item.nome">
                  <span class="text-subtitle-1 font-weight-bold"
                    >{{ index + 1 }}. {{ item.nome }}</span
                  >
                </v-container>
                <div>
                  <template v-if="item.qtd_itens_pedido">
                    <span class="text-subtitle-1">{{
                      item.qtd_itens_pedido
                    }}</span>
                  </template>
                  <template v-if="item.valor">
                    {{ item.valor | moeda }}
                  </template>
                </div>
              </v-list-item>
            </v-list>
          </v-col>
        </template>
        <template v-if="table">
          <v-col cols="12" sm="6" md="12">
            <v-data-table :headers="headers" :items="items" hide-default-footer>
              <template v-slot:item.data_pedido="{ item }">
                {{ item.data_pedido | data_pt_br }}
              </template>
              <template v-slot:item.valor_total="{ item }">
                {{ item.valor_total | moeda }}
              </template>
            </v-data-table>
          </v-col>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
export default {
  name: "DashCard",
  mixins: [displayHelpers],
  props: {
    refreshInfo: {
      type: String,
      required: false,
      default: "",
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "base",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    loading: {
      type: Boolean,
      required: false,
      default: true,
    },
    information: {
      type: Object,
      required: false,
      default: () => {},
    },
    percent: {
      required: false,
    },
    fillHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    table: {
      type: Boolean,
      required: false,
      default: false,
    },
    headers: {
      type: Array,
      required: false,
      default: () => [],
    },
    list: {
      type: Boolean,
      required: false,
      default: false,
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    info: {
      type: String,
      required: false,
      default: () => "",
    },
    infoCard: {
      type: String,
      required: false,
      default: () => "",
    },
    click: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    applyFillHeight() {
      return this.fillHeight ? "height: 100%" : "";
    },
    hasPercentContent() {
      return Object.keys(this.percent) >= 0;
    },
    isNegative() {
      return (
        this.percent.value.includes("-") || parseFloat(this.percent.value) < 0
      );
    },
    infoSpark() {
      return this.information?.values
        .map((value, index) => {
          return `${this.information?.titles[index]}: <b>${value}</b><br>`;
        })
        .join("");
    },
    valuesInfo() {
      const numericValues = this.information.values.map(value => {
        const numericValue = +value;
        return isNaN(numericValue) ? 0 : numericValue;
      });
      return numericValues;
    },
    shouldShowCards() {
      return (
        (!this.percent?.value?.includes("R$") &&
          this.information?.values?.length > 1) ||
        this.table ||
        this.list
      );
    },
    isValueBRL() {
      return this.percent?.value?.includes("R$");
    },
    isProducers() {
      return this.information?.values?.length > 1;
    },
  },
  methods: {
    refreshDashCard() {
      this.$dashboard.refreshDashInfo(this.refreshInfo);
    },
  },
};
</script>

<style scoped>
.dash-card2 {
  border-radius: 20px;
  margin: 0.5rem;
  background: #e9e8ed;
  box-shadow: 20px 20px 60px #c6c5c9;
  position: relative;
}
.dash-card {
  border-radius: 15px;
  margin: 0.5rem;
  /* background: #ffffff; */
  position: relative;
  background: rgb(242, 242, 242);
  background: linear-gradient(
    0deg,
    rgba(242, 242, 242, 1) 0%,
    rgba(252, 252, 252, 1) 17%,
    rgba(255, 255, 255, 1) 100%
  );
}
.positive-percent {
  color: #572c88;
  font-size: 0.875rem;
}

.positive-color {
  color: #739917;
}

.negative-percent {
  color: #d70200;
  font-size: 0.875rem;
}
.refresh-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
.card-dashboard {
  min-height: 200px;
  height: 100%;
}
@media (max-width: 1400px) {
  .card-dashboard {
    max-height: 445px;
    overflow-y: auto;
  }
}
@media (max-width: 1200px) {
  .card-dashboard {
    max-height: unset;
    overflow-y: unset;
  }
}
</style>
